import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-thin",
  "use": "plus-thin-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"plus-thin\"><path d=\"M389 230c10 0 15 9 15 26s-5 26-15 26H282v107c0 10-9 15-26 15s-26-5-26-15V282H123c-10 0-15-9-15-26s5-26 15-26h107V123c0-10 9-15 26-15s26 5 26 15v107h107\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol